import { useMemo } from "react";
import useTotalUserList from "./useTotalUserList";
import { CommonUtils } from "utils";
import { SystemConstant } from "const";

export default function useDepartmentUserList(
  departmentId,
  unitId,
  searchValue = "",
  page = SystemConstant.ACTIVE_PAGINATION,
) {
  const { totalUsers } = useTotalUserList();

  const isMatchingDept = user => {
    if (!departmentId) {
      return !user.departmentId;
    }
    return String(user.departmentId) === String(departmentId);
  };

  const isMatchingUnit = user => {
    if (!unitId) return true;
    return String(user.unitId) === String(unitId);
  };

  const departmentUserList = useMemo(() => {
    return totalUsers
      .filter(user => isStateCondition(user) && isMatchingDept(user) && isMatchingUnit(user))
      .map(user => ({ label: user.name, id: user.accountId }));
  }, [totalUsers, departmentId, unitId]);

  const query = (searchValue || "").trim().toLowerCase();
  const queryWithoutVN = CommonUtils.removeVietnameseTones(query);
  const queryPhone = query.replace("+84", "0");

  const departmentUserListFilter = useMemo(() => {
    return totalUsers
      .filter(user => {
        if (!isStateCondition(user) || !isMatchingDept(user) || !isMatchingUnit(user)) return false;
        if (!query) return true;
        const name = CommonUtils.removeVietnameseTones((user.name || "").toLowerCase());
        const mail = (user.mail || "").toLowerCase();
        const phone = user.phone || "";
        const phoneWithoutVN = phone.replace("+84", "0");
        return (
          name.includes(queryWithoutVN) ||
          mail.includes(query) ||
          phone.includes(query) ||
          phoneWithoutVN.includes(queryPhone)
        );
      })
      .map(user => ({ id: user.accountId, name: user.name, phone: user.phone, mail: user.mail }));
  }, [totalUsers, departmentId, unitId, query, queryWithoutVN, queryPhone]);

  const totalPages = Math.ceil(departmentUserListFilter.length / SystemConstant.USERS_LIMITED_NUMBER) || 1;

  const currentPageUsers = useMemo(() => {
    return CommonUtils.paginateFromArray(
      departmentUserListFilter,
      page,
      SystemConstant.USERS_LIMITED_NUMBER,
    );
  }, [departmentUserListFilter, page]);

  return {
    departmentUserList,
    totalPages,
    currentPageUsers,
  };
}

const isStateCondition = user => {
  let stateCondition = false;
  if (user.state !== 0 && user.state !== 2 && user.branchAccountState !== 0 && user.branchAccountState !== 2) {
    stateCondition = true;
  }
  return stateCondition;
};

